// @ts-nocheck
import React from "react";

interface Props { children: React.ReactNode; pageName: string }
interface State { error: Error | null; info: React.ErrorInfo | null }

export class PageBoundary extends React.Component<Props, State> {
  state: State = { error: null, info: null };
  static getDerivedStateFromError(error: Error): State { return { error, info: null }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[wht/${this.props.pageName}]`, error, info);
    this.setState({ info });
  }
  render() {
    if (this.state.error) {
      return (
        <div className="card p-6 space-y-3">
          <div className="text-base font-semibold text-rose-700">
            {this.props.pageName} crashed
          </div>
          <pre className="overflow-x-auto rounded-md bg-rose-50 p-3 text-xs text-rose-900 whitespace-pre-wrap">
            {this.state.error?.toString()}
          </pre>
          {this.state.info?.componentStack && (
            <details className="text-xs">
              <summary className="cursor-pointer text-slate-500">Component stack</summary>
              <pre className="mt-1 overflow-x-auto rounded-md bg-slate-50 p-3 text-[10px] text-slate-700 whitespace-pre-wrap">
                {this.state.info.componentStack}
              </pre>
            </details>
          )}
          <button className="btn-secondary" onClick={() => this.setState({ error: null, info: null })}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
